/**
 * AppIcon — renders a catalog app's real brand mark when we have one
 * (simple-icons, exact official colors), falling back to a plain lucide
 * glyph for apps simple-icons doesn't ship (Slack and Microsoft Teams were
 * both removed from simple-icons after trademark takedown requests).
 */

import React from 'react';

export function AppIcon({ app, size = 20, style }) {
  if (app.logo) {
    return (
      <svg role="img" aria-label={app.name} viewBox="0 0 24 24" width={size} height={size}
        style={style} fill={`#${app.logo.hex}`}>
        <path d={app.logo.path} />
      </svg>
    );
  }
  const Icon = app.icon;
  return <Icon size={size} style={{ color: app.color, ...style }} />;
}
